import { render, staticRenderFns } from "./index2022.vue?vue&type=template&id=0b2dd9e1&scoped=true"
import script from "./index2022.vue?vue&type=script&lang=js"
export * from "./index2022.vue?vue&type=script&lang=js"
import style0 from "./index2022.vue?vue&type=style&index=0&id=0b2dd9e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2dd9e1",
  null
  
)

export default component.exports